import Vue from '@triotech/vue-core/src/vendor/vue';

// This file allow to connect and disconnect the socketIO server
export default new Vue({
  created() {
    this.$bus.$on('t-event.login.success', this.socketConnected);
    this.$bus.$on('t-event.logout.success', this.socketDisconnected);
  },
  methods: {
    // On socket connected emit event 'manager_connect'
    socketConnected() {
      if (this.oauth()) {
        this.$socket.emit('manager_connect', { id: this.oauth().user.id });
      }
    },
    // On socket disconnected emit event 'manager_disconnect'
    socketDisconnected(id) {
      this.$socket.emit('manager_disconnect', { id });
    },
  },
  sockets: {
    // Connect socket
    connect() {
      this.socketConnected();
    },
    newNotif(val) {
      this.$bus.$emit('t-event.notification.new', val);
    },
  },
});




// WEBPACK FOOTER //
// ./src/plugins/socket.js